import script from "./SharedCharts.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedCharts.vue?vue&type=script&setup=true&lang=js"

import "./SharedCharts.vue?vue&type=style&index=0&id=36ca93da&lang=scss"

const __exports__ = script;

export default __exports__